export function genericAction(props) {
    return (dispatch) => {
        dispatch({ ...props });
    };
}
